import imageCompression from "browser-image-compression";
import { supabase } from "@/integrations/supabase/client";

export async function compressImage(file: File, maxSizeMB = 1, maxWidth = 1024): Promise<File> {
  return imageCompression(file, {
    maxSizeMB,
    maxWidthOrHeight: maxWidth,
    useWebWorker: true,
    fileType: "image/jpeg",
  });
}

export async function uploadToBucket(
  bucket: "user-photos" | "product-images" | "tryon-results",
  userId: string,
  file: Blob,
  ext = "jpg",
): Promise<string> {
  const path = `${userId}/${crypto.randomUUID()}.${ext}`;
  const { error } = await supabase.storage.from(bucket).upload(path, file, {
    contentType: file.type || "image/jpeg",
    upsert: false,
  });
  if (error) throw error;
  return path;
}

export async function signedUrl(
  bucket: "user-photos" | "product-images" | "tryon-results",
  path: string,
  expiresIn = 3600,
): Promise<string> {
  const { data, error } = await supabase.storage.from(bucket).createSignedUrl(path, expiresIn);
  if (error) throw error;
  return data.signedUrl;
}

export function dataUrlToBlob(dataUrl: string): Blob {
  const [header, b64] = dataUrl.split(",");
  const mimeMatch = header.match(/data:([^;]+)/);
  const mime = mimeMatch ? mimeMatch[1] : "image/png";
  const bin = atob(b64);
  const arr = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) arr[i] = bin.charCodeAt(i);
  return new Blob([arr], { type: mime });
}
